$(document).ready(function() {

filterSelection("all");  // Zeigt zuerst alle Elemente an
  
  function searchFunction() {
    var filter = $('#myInput').val().toUpperCase();

    $('.article-item').each(function() {
      var content = $(this).find('.article-title, .article-excerpt, .article-full-content').text().toUpperCase();
      if (content.indexOf(filter) > -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  $('#myInput').on('keyup', searchFunction);

  function filterSelection(c) {
    if (c === "all") {
      $('.filterDiv').show();
    } else {
      $('.filterDiv').hide();
      $('.filterDiv.' + c).show();
    }
  }

$(document).ready(function() {
  // Funktion zum Filtern der Blogbeiträge basierend auf dem ausgewählten Tag
  $('.btn').click(function() {
    console.log('Button clicked'); // Diese Zeile hinzufügen PRèFUNG
    var filter = $(this).attr('data-filter');
    console.log('Filter:', filter); // Diese Zeile hinzufügen PRèFUNG
    
    // Wenn der Filter 'all' ist, werden alle Beiträge angezeigt
    if (filter == 'all') {
      $('.article-item').show();
    } else {
      // Andernfalls werden alle Beiträge ausgeblendet und nur die Beiträge mit dem ausgewählten Tag werden angezeigt
      $('.article-item').hide();
      $('.article-item.' + filter).show();
    }

    // Der aktive Button-Stil wird auf den geklickten Button angewendet
    $('.btn.active').removeClass('active');
    console.log('Active class removed from previous active button');
    $(this).addClass('active');
    console.log('Active class added to clicked button');
  });

  // Optional: Funktion zum Anzeigen einer begrenzten Anzahl von Wörtern in den Blogbeiträgen (für eine schönere Darstellung)
  $('.article-item p').each(function() {
    var text = $(this).text();
    var words = text.split(' ');

    if (words.length > 30) {
      var newText = words.slice(0, 30).join(' ') + '...';
      $(this).text(newText);
    }
  });
});

});
